import { combineReducers } from "redux";

import authReducer from "../../routes/Auth/redux/reducers";
import adminReducer from "../../routes/Admin/redux/reducers";


const appReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;